import { Component } from '@angular/core';
import { slideInUpOnEnterAnimation } from 'angular-animations';

@Component({
  selector: 'the-initiative',
  standalone: true,
  imports: [],
  templateUrl: './the-initiative.component.html',
  styleUrl: './the-initiative.component.scss',
  animations: [slideInUpOnEnterAnimation({ anchor: 'slideInOut' })],
})
export class TheInitiativeComponent {}
